// components/PublicRoute.js
import React from 'react'
import { Route, Redirect } from 'react-router-dom'
import { useSelector } from 'react-redux'

export default function PublicRoute({
	component: Component,
	roles = [],
	...rest
}) {
	const isAuthenticated = useSelector((state) => state.auth.isAuthenticated)
	const user = useSelector((state) => state.auth.user)

	const renderRedirectByRole = (role) => {
		switch (role) {
			case 'admin':
			case 'super admin':
			case 'admin service après vente':
			case 'admin distribution':
				return <Redirect to='/admin/clients' />
			case 'client':
				return <Redirect to='/commandes/new' />
			case 'chauffeur':
				return <Redirect to='/chauffeur/transports' />
			case 'transporter':
				return <Redirect to='/transports' />
			case 'admin comptabilité':
				return <Redirect to='/admin/plateforme/facturation' />
			case 'commercial':
				return <Redirect to='/commercial/client/new' />
			case 'user':
			default:
				return <Redirect to='/' />
		}
	}

	return (
		<Route
			{...rest}
			render={(props) => {
				if (isAuthenticated) {
					return renderRedirectByRole(user?.role)
				}
				// Not authenticated => allow access
				return <Component {...props} />
			}}
		/>
	)
}
